import script from "./TeamInformationFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamInformationFormPage.vue?vue&type=script&setup=true&lang=js"

import "./TeamInformationFormPage.vue?vue&type=style&index=0&id=0ed86b38&lang=css"

const __exports__ = script;

export default __exports__